export const exportExcel = (function () {
  return {
    methods: {
      dataToExcel (data, docName = 'excel') {
        let url = window.URL.createObjectURL(data)
        let link = document.createElement('a')
        link.href = url
        link.style.display = 'none'
        link.setAttribute('download', `${docName}.xls`)
        link.setAttribute('target', '_blank')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }
})()

export const downloadFromUrl = (function () {
  return {
    methods: {
      downloadFromUrl (fileurl) {
        let fileName = fileurl.split('/').pop()
        let link = document.createElement('a')
        link.href = fileurl
        link.style.display = 'none'
        link.setAttribute('download', fileName)

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }
})()
export const preDelete = (() => {
  return {
    methods: {
      preDelete (msg = '确认删除?') {
        return new Promise((resolve, reject) => {
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            resolve()
          }).catch(() => {
            reject(new Error('已取消删除'))
          })
        })
      }
    }
  }
})()

/**
 * 重置Form表单组件下的选项值
 *
 * @return  {[type]}  [return description]
 */
export const resetForm = (() => {
  return {
    methods: {
      resetForm (formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
})()

export const confirm = (() => {
  return {
    methods: {
      confirm (tipText, callback, cancel) {
        this.$confirm(tipText, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            callback()
          })
          .catch(() => {
            console.log(cancel)
            cancel && cancel()
            return false
          })
      }
    }
  }
})()

export const validateForm = (() => {
  return {
    methods: {
      validateForm (form) {
        return new Promise((resolve, reject) => {
          form.validate(valid => {
            if (valid) {
              resolve()
            } else {
              this.$message.error('请完善必填信息！')
              // reject(new Error('请完善信息！'));
            }
          })
        })
      }
    }
  }
})()



// WEBPACK FOOTER //
// ./src/mixins/index.js